import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setUpdateStations } from "../redux/slices/app.slice";
import { setOpenedStations } from "../redux/slices/stations.slice";
import { TZDate } from "@date-fns/tz";
import { checkStationAvailability } from "../utils/checkStationAvailability";

export function useCurrentStations() {
  const dispatch = useDispatch();
  const stations = useSelector((state) => state.stations.openedStations);
  const timezone = useSelector((state) => state.app.timezone);
  const nearestSlot = useSelector((state) => state.app.nearestSlot);

  const cleanStations = () => {
    const now = TZDate.tz(timezone);

    if (stations?.length > 0) {
      const filtered = stations.filter((station) =>
        checkStationAvailability(station, timezone),
      );

      if (filtered.length !== stations.length) {
        dispatch(setOpenedStations(filtered));
      }
    }

    if (nearestSlot) {
      const [h, m, s] = nearestSlot.split(":").map(Number);
      const slotStart = new TZDate(
        now.getFullYear(),
        now.getMonth(),
        now.getDate(),
        h,
        m,
        s,
        timezone,
      );

      if (now >= slotStart) {
        dispatch(setUpdateStations(true));
      }
    }
  };

  useEffect(() => {
    let interval = setInterval(cleanStations, 10000);

    const handleVisibility = () => {
      if (document.visibilityState === "visible") {
        cleanStations();

        clearInterval(interval);
        interval = setInterval(cleanStations, 10000);
      } else {
        clearInterval(interval);
      }
    };

    document.addEventListener("visibilitychange", handleVisibility);

    return () => {
      clearInterval(interval);
      document.removeEventListener("visibilitychange", handleVisibility);
    };
  }, [stations, timezone, nearestSlot]);

  return null;
}
